import React, { Component } from 'react';
import ResetPasswordWizard from './ResetPasswordWizard';

export class ResetPassword extends Component {
  static displayName = ResetPassword.name;

  render() {
    return (
      <div>
        <ResetPasswordWizard />
      </div>
    );
  }
}
